import { PWSSessionBackend } from "../../../../../../core/lib/auth/backends/pws";
import { PwsViewUserResponse } from "../../../../../../core/services/PWS.types";
import { Button, ButtonKind } from "../../../../../../core/ui";
import { CoastAlert } from "../../common/coast-alert/CoastAlert.model";
import { CoastAccountUpdateEmail } from "./CoastUserUpdateEmail.component";
import { CoastUserUpdatePassword } from "./CoastUserUpdatePassword.component";

interface CoastUserUpdateLoginInfoProps {
    goBack: (v?: CoastAlert[]) => void;
    userData: PwsViewUserResponse;
    session: PWSSessionBackend;
}

export function CoastUserUpdateLoginInfo({ userData, session, goBack }: CoastUserUpdateLoginInfoProps) {
    return (
        <div className="component-coast-account-change-login">
            <Button className="button-back-to-account" kind={ButtonKind.CUSTOMIZED} click={() => goBack()}>
                Back to Account Settings
            </Button>

            <CoastAccountUpdateEmail userData={userData} session={session} />

            <hr className="divider" />

            <CoastUserUpdatePassword userData={userData} session={session} />
        </div>
    );
}
